import React from 'react';
import '../css/LinksComponent.css';
//import { FaExternalLinkAlt } from 'react-icons/fa';

const externalResources = [
  {
    name: 'EMBL-EBI',
    url: 'https://www.ebi.ac.uk/ena/browser/text-search?query=Eragrostis%20tef',
    logo: `${process.env.PUBLIC_URL}/images/embl.png`,
    description: 'European Bioinformatics Institute (ENA) repository for genomic data of Eragrostis tef.'
  },
  {
    name: 'Ensembl Plants',
    url: 'https://plants.ensembl.org/Eragrostis_tef/Info/Index',
    logo: `${process.env.PUBLIC_URL}/images/ensembl_logo.png`,
    description: 'Genomic and annotation data of Eragrostis tef from Ensembl Plants platform.'
  },
  {
    name: 'UniProt',
    url: 'https://www.uniprot.org/uniprotkb?query=Eragrostis+tef',
    logo: `${process.env.PUBLIC_URL}/images/uniprot.png`,
    description: 'Protein knowledgebase including Eragrostis tef functional and sequence data.'
  },
  {
    name: 'PlantTFDB',
    url: 'https://planttfdb.gao-lab.org/index.php?sp=Ete',
    logo: `${process.env.PUBLIC_URL}/images/planttfdb.png`,
    description: 'Plant Transcription Factor Database with detailed TF profiles of Eragrostis tef.'
  },
  {
    name: 'NCBI',
    url: 'https://www.ncbi.nlm.nih.gov/search/all/?term=Eragrostis%20tef',
    logo: `${process.env.PUBLIC_URL}/images/ncbi.jpeg`,
    description: 'National Center for Biotechnology Information: taxonomy, gene, genome, and sequence data for Eragrostis tef.'
  }
];

const LinksComponent = () => {
  return (
    <div className="links-container">
      <h1>🔗 External Resources for <em><i>Eragrostis tef</i></em></h1>
      <p className="links-subtext">
        Access curated genomic, transcriptomic, proteomic, and regulatory datasets from reputable platforms.
      </p>

      <div className="links-grid">
        {externalResources.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-card"
          >
            <div className="link-logo">
              <img src={link.logo} alt={`${link.name} logo`} />
            </div>
            <div className="link-content">
              
              <p>{link.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinksComponent;

